<template>
<!-- HEAD -->
<div class="container-xxl">
    <!-- titol -->
    <div class="row justify-content-between">
        <div class="col-12 col-lg-4 py-4 text-start">
            <p class="txtBlau2 my-0">{{ $t('site.avanzando-hacia-el-futuro')}}</p>
            <h2>{{ $t('excelencia.excelencia')}}</h2>
        </div>
        <div class="col-6 text-start py-5 d-none d-lg-block">
            <h5>{{ $t('excelencia.la-extension-procesos')}}</h5>
        </div>
    </div>
</div>
<div class="container-fluid">
    <!-- foto -->
    <div class="row">
        <div class="col-12 p-0 m-0 overflow-hidden">
            <img :src="`${publicPath}img/01avanzandoExcelencia.jpg`" class="img-responsive" id="imgCrecimiento">
        </div>
    </div>
    <div class="row d-block d-lg-none">
        <div class="col-11 mx-3 mt-3 text-start">
            <h5>{{ $t('excelencia.la-extension-procesos')}}</h5>
        </div>
    </div>

</div>
<!-- end HEAD -->

    <!-- Content -->
    <div class="container-xxl">
        <div class="franjaODS d-none d-lg-block">
            <ul>
                <li class="odsTxt">{{ $t('site.ODS-impacto-directo')}}</li>
                <li><img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive"></li>
                <li style="width: 90px"></li>
                <li class="odsTxt">{{ $t('site.ODS-impacto-indirecto')}}</li>
                <li><img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive"></li>
            </ul>

        </div>
        <div class="franjaODS d-block d-lg-none">
            <div class="row justify-content-between p-0 m-0">
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>
                </div>
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>

    <div class="container-xxl">
        <div class="row justify-content-center mt-5 mt-lg-2">
            <div class="col-11 col-lg-7 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="py-5">
                    <h2 class="mb-5">{{ $t('excelencia.optimizacion-cadena')}}</h2>
                    <h5 class="txtGris">{{ $t('excelencia.tras-dos-ejercicios')}}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid ">
        <div class="row mt-2">
            <div class="col-12 p-0 p-lg-5 py-lg-0 position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000" style="background-color: #0E0E0E">
                <!-- capes blanques -->
                    <div class="capaExcelenciaA p-3" v-if="capaA">
                        <div class="btnClose svg svg-closeBtn text-end" @click="capaA=false"></div>

                        <div class="row">
                            <div class="col-2 col-lg-3 text-end">
                                <div class="p-0 me-5 fullHeight position-relative">
                                    <svg class="position-absolute bottom-0" viewBox="0 0 60 60" width="60">
                                        <use :href="`${publicPath}icons.svg#tms`"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-10 col-lg-8 text-start txtGrisFosc p-0">
                                <img :src="`${publicPath}img/camio.png`" class="img-responsive">
                                <h4 class="txtGrisFosc mt-4">{{ $t('excelencia.tms')}}</h4>
                                <p class="pe-0 pe-lg-5">{{ $t('excelencia.modelo-planificacion')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="ppe-0 pe-lg-5">{{ $t('excelencia.integracion-medidas')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-0 pe-lg-5">{{ $t('excelencia.hito-aplicacion')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="capaExcelenciaB p-3" v-if="capaB">
                        <div class="btnClose svg svg-closeBtn text-end" @click="capaB=false"></div>
                        <div class="row">
                            <div class="col-2 col-lg-3 text-end">
                                <div class="p-0 me-5 fullHeight position-relative">
                                    <svg class="position-absolute bottom-0" viewBox="0 0 60 60" width="60">
                                        <use :href="`${publicPath}icons.svg#tms`"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-10 col-lg-8 text-start txtGrisFosc p-0">
                                <img :src="`${publicPath}img/proveedors.png`" class="img-responsive">
                                <h4 class="txtGrisFosc mt-4">{{ $t('excelencia.portal')}}</h4>
                                <p class="pe-5">{{ $t('excelencia.centralizacion-plataforma')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-5">{{ $t('excelencia.integracion-proceso')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-5">{{ $t('excelencia.apuesta-concentracion')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-5">{{ $t('excelencia.hito-despliegue')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="capaExcelenciaC p-3" v-if="capaC">
                        <div class="btnClose svg svg-closeBtn text-end" @click="capaC=false"></div>
                        <div class="row">
                            <div class="col-2 col-lg-3 text-end">
                                <div class="p-0 me-5 fullHeight position-relative">
                                    <svg class="position-absolute bottom-0" viewBox="0 0 60 60" width="60">
                                        <use :href="`${publicPath}icons.svg#tms`"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-10 col-lg-8 text-start txtGrisFosc p-0">
                                <img :src="`${publicPath}img/integrated.png`" class="img-responsive">
                                <h4 class="txtGrisFosc mt-4">{{ $t('excelencia.IBP')}}</h4>
                                <p class="pe-5">{{ $t('excelencia.proceso-comun')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-5">{{ $t('excelencia.foco-gestion')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-5">{{ $t('excelencia.hito-implantacion_a')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="capaExcelenciaD p-3" v-if="capaD">
                        <div class="btnClose svg svg-closeBtn text-end" @click="capaD=false"></div>
                        <div class="row">
                            <div class="col-2 col-lg-3 text-end">
                                <div class="p-0 me-5 fullHeight position-relative">
                                    <svg class="position-absolute bottom-0" viewBox="0 0 60 60" width="60">
                                        <use :href="`${publicPath}icons.svg#tms`"/>
                                    </svg>
                                </div>
                            </div>
                            <div class="col-10 col-lg-8 text-start txtGrisFosc p-0">
                                <img :src="`${publicPath}img/venta.png`" class="img-responsive">
                                <h4 class="txtGrisFosc mt-4">{{ $t('excelencia.digitalizacion')}}</h4>
                                <p class="pe-5">{{ $t('excelencia.soporte-tecnico')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-5">{{ $t('excelencia.soluciones-mejorar')}}</p>
                                <hr class="borderGrisClar me-5">
                                <p class="pe-5" v-html="$t('excelencia.hito-implantacion')"></p>
                            </div>
                        </div>
                    </div>
                <!-- end capes blanques -->
                <!-- butons -->
                    <div class="btnExcelenciaA" @click="capaA=true"></div>
                    <div class="btnExcelenciaB" @click="capaB=true"></div>
                    <div class="btnExcelenciaC" @click="capaC=true"></div>
                    <div class="btnExcelenciaD" @click="capaD=true"></div>
                <!-- end butons -->
                <img :src="`${publicPath}img/01avanzandoExcelenciaEsquema_${locale}.jpg`" class="img-responsive d-none d-lg-block">
                <img :src="`${publicPath}img/01avanzandoExcelenciaEsquemaMobile_${locale}.jpg`" class="img-responsive d-block d-lg-none">
            </div>
        </div>
    </div>

    <div class="container-xxl">
        <div class="row g-3 mt-2 mb-5 gb-5">
            <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-3 text-start">
                    <h2>{{ $t('excelencia.gestion-marcas')}}<br></h2>
                    <p class="txtGris">{{ $t('excelencia.RG-cuenta')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-7 mb-5">
                <div class="row g-3 mt-2 mb-5">
                    <div class="col-12 col-lg-3 aos-init aos-animate mb-5" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <h4 class="text-start" v-html="$t('excelencia.marcas-globales')"></h4>
                        <div class="bg-white px-4 fullHeight" style="display: flex;align-items: center;flex-wrap: wrap;">
                            <img :src="`${publicPath}img/01avanzandoExcelenciaLogosA.png`" class="img-responsive m-auto d-none d-lg-block">
                            <img :src="`${publicPath}img/01avanzandoExcelenciaLogosAMobile.png`" class="img-responsive m-auto d-block d-lg-none">
                        </div>
                    </div>
                    <div class=" col-12 col-lg-6 aos-init aos-animate mb-5" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                        <h4 class="text-start" v-html="$t('excelencia.marcas-locales')"></h4>
                        <div class="bg-white p-3 fullHeight text-center" style="display: flex;align-items: center;flex-wrap: wrap;">
                            <img :src="`${publicPath}img/01avanzandoExcelenciaLogosB.png`" class="img-responsive m-auto">
                        </div>
                    </div>
                    <div class=" col-12 col-lg-3 aos-init aos-animate mt-5 mt-lg-3 mb-0 mb-lg-5" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                        <h4 class="text-start">{{ $t('excelencia.marcas-especialistas')}}</h4>
                        <div class="bg-white px-3 fullHeight text-center" style="display: flex;align-items: center;flex-wrap: wrap;">
                            <img :src="`${publicPath}img/01avanzandoExcelenciaLogosC.png`" class="img-responsive m-auto m-auto d-none d-lg-block">
                            <img :src="`${publicPath}img/01avanzandoExcelenciaLogosCMobile.png`" class="img-responsive m-auto d-block d-lg-none">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid pb-0 pb-lg-5">
        <div class="row g-3 mt-2 mb-5 pb-5">
            <div class="col-12 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="bg-dark p-5 text-start fullHeight">
                    <h4 class="mb-4 px-3">{{ $t('excelencia.reduccion-complejidad')}}</h4>
                    <p class="txtGris px-3">{{ $t('excelencia.el-grupo-sigue')}}</p>
                </div>
            </div>
        </div>
    </div>


    <div class="container-xxl">
        <div class="row position-relative p-0 m-0">
            <div class="col-12 col-lg-5 capaTrans text-start pt-0 pt-lg-5">
                <h2 class="mt-5 pe-1">{{ $t('excelencia.roca-LAUFEN')}}</h2>
                <h4 class="my-5 sizePlus txtGris pe-0 pe-lg-5">{{ $t('excelencia.integrado-prestigiosa')}}</h4>
            </div>
            <div class="col-12 p-0 m-0">

                <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img :src="`${publicPath}img/Excelencia-operacional-Fuorisalone-1.jpg`" class="img-responsive mb-4">
                        </div>
                        <div class="carousel-item">
                            <img :src="`${publicPath}img/Excelencia-operacional-Fuorisalone-2.jpg`" class="img-responsive mb-4">
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                        <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                        <span class="visually-hidden">{{ $t('previous') }}</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                        <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                        <span class="visually-hidden">{{ $t('next') }}</span>
                    </button>
                </div>


            </div>
        </div>
    </div>

    <div class="container-xxl mb-0 mb-lg-5 pb-0 pb-lg-5">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-6 text-start aos-init aos-animate" data-aos="fade-down" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                    <h4 class="my-4 col-6">{{ $t('excelencia.debut-Roca')}}</h4>
                    <p class="txtGris col-12 col-lg-10">{{ $t('excelencia.en-su-primera-participacion')}}</p>
            </div>
            <div class=" col-12 col-lg-6 text-start aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <h4 class="my-4 col-6">{{ $t('excelencia.instalacion-multimedia')}}</h4>
                    <p class="txtGris col-12 col-lg-10">{{ $t('excelencia.por-su-parte')}}</p>
            </div>
        </div>
        <hr class="my-5 borderGris">

    </div>

    <div class="container-xxl">
        <div class="row position-relative p-0 m-0">
            <div class="col-12 col-lg-5 capaTransR text-start pt-0 pt-lg-5">
                <h2 class="mt-5 pe-1">{{ $t('excelencia.mejora-continua')}}</h2>
                <h4 class="mt-5 txtGris pe-0 pe-lg-5">{{ $t('excelencia.la-excelencia-operacional')}}</h4>
            </div>
            <div class="col-12 p-0 m-0">


                <div id="carouselExampleControls2" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img :src="`${publicPath}img/Excelencia-operacional-Mejora-procesos-1.jpg`" class="img-responsive mb-4">
                        </div>
                        <div class="carousel-item">
                            <img :src="`${publicPath}img/Excelencia-operacional-Mejora-procesos-2.jpg`" class="img-responsive mb-4">
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="prev">
                        <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                        <span class="visually-hidden">{{ $t('previous') }}</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls2" data-bs-slide="next">
                        <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                        <span class="visually-hidden">{{ $t('next') }}</span>
                    </button>
                </div>


            </div>
        </div>
    </div>

    <div class="container-xxl">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-6 text-start aos-init aos-animate" data-aos="fade-down" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                <h4 class="my-4">{{ $t('excelencia.nueva-formulacion-resinas')}}</h4>
                <p class="txtGris col-12 col-lg-10">{{ $t('excelencia.importante-inversion')}}</p>
            </div>
            <div class=" col-12 col-lg-6 text-start aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <h4 class="my-4">{{ $t('excelencia.linea-cromo')}}</h4>
                <p class="txtGris col-12 col-lg-10">{{ $t('excelencia.RG-sigue')}}</p>
            </div>
        </div>
        <hr class="my-5 borderGris">

    </div>

    <div class="container-xxl">
        <div class="row justify-content-between g-3 mt-2 py-0 py-lg-5">
            <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-0 text-start">
                    <h2 class="mb-5">{{ $t('excelencia.gestion-integrada')}}</h2>
                    <p class="txtGris" v-html="$t('excelencia.La-reciente-incorporacion')"></p>
                    <p class="txtGris" v-html="$t('excelencia.con-este-objetivo')"></p>
                    <p class="txtGris" v-html="$t('excelencia.PMO')"></p>
                    <p class="txtGris" v-html="$t('excelencia.TECHNICAL-OFFICE')"></p>
                    <p class="txtGris" v-html="$t('excelencia.ambas-iniciativas')"></p>
                </div>
            </div>

            <div class="col-12 col-lg-6 position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
                <img :src="`${publicPath}img/01avanzandoExcelenciaB.jpg`" class="img-responsive text-end">
            </div>
        </div>
    </div>

    <!-- end Content -->

    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/crecimiento" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.crecimiento") }}</h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/innovacion" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.innovacion") }}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->

</template>
<script>
  export default {
    name: "AvanzandoHaciaElFuturoExcelenciaOperacionalView",
      data() {
          return {
              publicPath: process.env.BASE_URL,
              capaA: false,
              capaB: false,
              capaC: false,
              capaD: false,
              locale:this.$i18n.locale,
          }
      },
      methods: {
          nomfuncio: function (variable) {
              // `this` inside methods point to the Vue instance
              this.capaA = false
              alert('Hello ' + variable + '!');
              // `event` is the native DOM event
              alert(variable)
          }
      }
  }

</script>
